//chapter1
export default {
    id : 12,//chapter number
    title : '12. 패키지 쏘잉 & 쏘팅 공정(Sawing & Sorting) (2)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/12/videos/a12.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '쏘잉 & 쏘팅 공정의 의의',
                '공정 순서',
            ],
            body2 : [
                '쏘잉 & 쏘팅 공정의 의의에 대해 설명할 수 있다.',
                '공정 순서에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/12/videos/12.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : 'PCB를 사용하는 패키지는 패키지 쏘잉 공정이 반드시 필요하다.',//html available
                    answer : "1",
                    explain : 'PCB를 사용하는 패키지는 패키지 쏘잉 공정을 통해서 패키지 개별화 작업이 진행이 된다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '패키지 쏘잉은 패키지 종류별로 별도의 쏘잉 툴을 제작해야 작업이 가능하다.',//html available
                    answer : "1",
                    explain : '패키지 쏘잉을 하기 위해서는 패키지 종류별로 별도의 쏘잉툴이 있어야 작업이 가능하다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>쏘잉 & 쏘팅 공정의 의의<br>
                        - Strip으로부터 PKG를 개별화 시켜주는 쏘잉 공정<br>
                        - 개별화된 PKG를 Vision을 통해 양품/불량 검사 후 분류하는 쏘팅 공정</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>공정 순서<br>
                        ① 자재 공급<br>
                        - 몰딩이 완료된 상태의 PCB를 매거진(M/Z)에 담아 M/Z 로더에 장착하고 M/Z 로더를 동작시켜 메거진 엘리베이터 구동부까지 이송시킴<br>
                        ② 자재 이송<br>
                        - PCB 푸셔는 PCB를 In-let Rail부까지 이송시키고 PCB 도착 센서가 동작하면 Gripper가 작동되어 Strip 픽업 위치까지 이송함<br>
                        ③ Sawing<br>
                        - 척 테이블에서 소잉이 진행되는 동안 유닛 픽커는 새로 공급된 PCB를 집어 올림<br>
                        - 쏘잉이 완료되면 Strip 피커가 척 테이블로 다시 이동하여 완료된 패키지와 교체함<br>
                        ④ Cleaning<br>
                        - 쏘잉이 끝난 PCB는 Strip 피커에 의해 크리너 부로 이송 후 크리닝 작업을 실시함<br>
                        - 크리닝 작업이 완료되면 스트립 피커가 패키지를 Reversible Unit으로 이송시킴
                        </li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>공정 순서<br>
                        ⑤ 건조<br>
                        - 체크가 완료된 패키지는 Reversible Table Base에서 Hot Air Blower로 물기를 건조하고, Strip 피커는 In-let Rail로 이동, 같은 동작을 반복함<br>
                        ⑥ 검사(Mark) <br>
                        - 팔렛 테이블에 위치한 패키지의 마킹면의 검사를 진행함<br>
                        ⑦ 검사(Ball)<br>
                        - 마킹면의 검사가 완료된 패키지는 칩 피커에 의해서 볼 비전 검사위치로 이동해서 검사를 실시함<br>
                        ⑧ 정렬<br>
                        - 마킹 검사와 볼 검사과정을 통해서 얻어진 데이터로 Good 패키지와 Rework 패키지로 분류됨<br>
                        - 분류된 패키지는 칩 피커에 의해 Good Tray와 Rework Tray로 옮겨주는 과정을 되풀이 함
                        </li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/12/videos/a12.mp4',
        },
    ]
}